
import StopCircle from "../../../assets/duotone/StopCircle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function StopCircleIcon({ className, dataTestid = "StopCircleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <StopCircle data-testid={dataTestid} className={classes} {...rest} />
  );
}
